<template>
  <div>
    <div class="header">
      <header-tag :title="'微信绑定'"></header-tag>
    </div>
    <div class="form-body">
      <img
        src="@/assets/img/login/wt.png"
        alt=""
      />
      你确定要解除绑定微信？
    </div>
    <div class="footer">
      <button @click="getUnbind">确认</button>
      <button @click="closeWxUntied">取消</button>
    </div>
  </div>
</template>
<script>
import { getUnbindWx } from "@/requests/safe";
import HeaderTag from "_c/tagTitle/headerTag";
export default {
  name: "changeUntied",
  components: {
    HeaderTag
  },
  data() {
    return {
      showPwd: false
    };
  },
  methods: {
    // 关闭微信解绑弹框
    closeWxUntied() {
      this.showUntied = false;
      this.showBindWX = false;
      this.$emit("showUntied", false);
    },
    async getUnbind() {
      await getUnbindWx();
      this.closeWxUntied();
      this.$router.go(0);
    }
  },
  mounted() {
    //监听键盘按键事件
    let self = this
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.closeWxUntied()
        }
      })
    })
  }
};
</script>
<style lang="scss" scoped>
.form-body {
  overflow: hidden;
  width: 100%;
  padding: 20px 0px 10px 0px;
  line-height: 50px;
  text-align: left;
  img {
    float: left;
    margin: 17px 10px 0 70px;
    // line-height: 50px;
  }
}
.header {
  padding-left: 30px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d9dee4;
}
.footer {
  margin-top: 20px;
  padding: 20px 0;
  margin-left: 5%;
  width: 90%;
  text-align: right;
  border-top: 1px solid #d9dee4;
  button {
    width: 100px;
    line-height: 30px;
  }
  button:nth-child(1) {
    background-color: rgb(0, 153, 204);
    border: 1px solid rgb(0, 153, 204);
    color: #fff;
  }
  button:nth-child(2) {
    margin-left: 10px;
    background-color: rgb(247, 247, 247);
    border: 1px solid #d9dee4;
  }
}
</style>
